export const ORDER_INVOICE = {
    title: '关联发票',
    dialog: 'step',
    fields: [
        {
            type: 'selections',
            field: 'invoiceList',
            keyField: 'id', nameField: 'invoiceNo', module: 'fmpInvoice',
            queryFields: ["invoiceNo"],
            listFields: [
                "invoiceNo",
                {
                    "field": "batchId",
                    "type": "link"
                },
                {
                    "field": "invoiceClass",
                    "relPath": [
                        "invoiceClass.name"
                    ]
                },
                {
                    "field": "invoiceType",
                    "relPath": [
                        "invoiceType.name"
                    ]
                },
                "taxesRate",
                "buyerName",
                "issueTime",
                "payeeName",
                {
                    "field": "fmStatus",
                    "relPath": [
                        "fmStatus.name"
                    ]
                },
                {
                    "field": "invoiceStatus",
                    "relPath": [
                        "invoiceStatus.name"
                    ]
                }
            ]
        },
        {
            type: 'form',
            fields: [
                {
                    name: "订单",
                    field: "orderId",
                    selectType: 1,
                    config: "ORDER_SELECTION",
                    map: { aorderId: "orderId" },
                    rel: "fmpOrder.id",
                    relPath: ["fmpOrder.orderName"],
                    rules: [
                        "required"
                    ],
                    readonly: true,
                },
                {
                    name: "执行明细",
                    field: "implId",
                    selectType: 1,
                    query: "orderId={aorderId}",
                    config: "ORDERIMP_SELECTION",
                    rel: "fmpOrderImpl.id",
                    relPath: ["fmpOrderImpl.orderImplNo"]
                },
                {
                    field: "invoiceList",
                    type: "table",
                    view: {
                        module: "fmpInvoice",
                        fields: [
                            "invoiceNo",
                            {
                                "field": "bizTypeCode",
                                "relPath": [
                                    "mdmBizType.bizTypeName"
                                ]
                            },
                            {
                                "field": "invoiceType",
                                "relPath": [
                                    "invoiceType.name"
                                ]
                            },
                            {
                                "field": "assignedAmount",
                                "name": "认领金额",
                                "type": "input"
                            },
                        ]
                    },
                    "defaultFields": ["selection", "index"],
                    "withDefaultButtons": false,
                }
            ]
        }
    ]
}